export default __webpack_public_path__ + "static/media/wac02.acbea8ab.jpg";